import { NoPhotoAvatar } from '../NoPhotoAvatar';

export interface PractitionerPhotoProps {
  photo?: string;
  size: 'sm' | 'md' | 'lg';
  name: string;
}

export const PractitionerPhoto = ({
  photo,
  size,
  name,
}: PractitionerPhotoProps) => {
  const sizeClass =
    size === 'sm'
      ? 'h-16 w-16 min-w-16'
      : size === 'md'
        ? 'h-24 w-24 min-w-24'
        : 'h-32 w-32 min-w-32';
  return (
    <div
      className={`flex items-center justify-center overflow-hidden rounded-full border border-neutral-20 bg-neutral-30 ${sizeClass}`}
    >
      {photo && photo.startsWith('https') ? (
        <img
          data-testid="practitioner-photo"
          src={photo}
          alt={`${name}'s headshot`}
          className="h-full w-full object-cover"
        />
      ) : (
        <NoPhotoAvatar />
      )}
    </div>
  );
};
